var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHide = function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78 21 21.53 3M9.066 19.032c.95.314 1.94.472 2.934.467 4.01.072 8.077-2.914 10.58-5.848.27-.315.42-.725.42-1.151 0-.426-.15-.836-.42-1.15a20.065 20.065 0 0 0-3.002-2.863M16.977 6.818A10.56 10.56 0 0 0 12 5.501C8.089 5.43 3.982 8.353 1.42 11.35A1.77 1.77 0 0 0 1 12.5c0 .426.15.836.42 1.15a19.829 19.829 0 0 0 4.82 4.148",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.07a3.85 3.85 0 0 1 5.5-5.28M15.75 12.75A3.75 3.75 0 0 1 12 16.5",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHide;